module.exports = __webpack_public_path__ + "media/img/stalowe@3x-dark-d5f2c7d0.svg";